const $ = require("jquery");

const SticyNav = {

  init() {
    const $el = $('.js-sticky-nav');
    const $elTop = $('.c-navbar--sticky-wrapper .js-sticky-nav');
    if( $elTop.length > 0 ){
      let headerHeight = $('header').outerHeight(true);

      menuItemActive('.c-navbar--sticky-top');
      $(window).on('hashchange', function() {
        menuItemActive('.c-navbar--sticky-top');
      })

      $(window).scroll(function(e){
        let $window  = $(window);
        const isPositionFixed = ($elTop.css('position') == 'fixed');

        if ($window.scrollTop() > headerHeight && !isPositionFixed){
          TopMenuFixed(true, $elTop);
        }else if($window.scrollTop() < headerHeight){
          TopMenuFixed(false, $elTop);
        }

        $('.u-anchor').each(function() {
          const anchor = $(this);
          const anchorHash = '#'+anchor.attr('id');
          const position = anchor.offset().top - $(window).scrollTop() - 100;
          if (position <= 0) {
            $('.c-navbar--sticky-top li').removeClass('active');
            $('.c-navbar--sticky-top a[href="'+anchorHash+'"]').parent().addClass('active');
          } 
        });
      });
    }
    else if ( $el.length > 0 ) {
      if ($(window).width() >= '992') {
        let headerHeight = $('header').height() - 30;
        const distance = $('.c-sidebar--sticky-wrapper').offset().top - 65;
        const maxHeight = $('.c-sidebar--sticky-wrapper').height() - 50;

        menuItemActive('.c-sidebar--sticky-left');
        $(window).on('hashchange', function() {
          menuItemActive('.c-sidebar--sticky-left');
        })

        $(window).scroll(function(e){
          let $window  = $(window);
          const isPositionFixed = ($el.css('position') == 'fixed');

          if ( $window.scrollTop() >= distance && $window.scrollTop() < maxHeight && !isPositionFixed){
          sidebarMenuFixed(true, $el, headerHeight);

          }
          if (($window.scrollTop() < distance || $window.scrollTop() > maxHeight) && isPositionFixed){
          sidebarMenuFixed(false, $el);
          }

          $('.u-anchor').each(function() {
            const anchor = $(this);
            const anchorHash = '#'+$(this).attr('id');
            const position = anchor.offset().top - $(window).scrollTop();
            if (position <= 0) {
              $('.c-sidebar--sticky-left li').removeClass('active');
              $('.c-sidebar--sticky-left a[href="'+anchorHash+'"]').parent().addClass('active');
            } 
          });
        });
      }
    }

    function sidebarMenuFixed(isFixed, menu, headerHeight = 0){
      if(isFixed){
        menu.addClass('fixed');
        menu.css({'position': 'fixed', 'top': headerHeight+'px'});
      }else{
        menu.removeClass('fixed');
        menu.css({'position': 'absolute', 'top':'0px'});
      }
    }

    function TopMenuFixed(isFixed, menu){
      if(isFixed){
        menu.removeClass('u-hide');
        menu.addClass('fixed');
        menu.css({'position': 'fixed', 'top': '0px', 'z-index':800});
        $('#site-nav, #toolbar-administration').hide();
      }else{
        menu.addClass('u-hide');
        menu.removeClass('fixed');
        menu.css({'position': 'absolute'});
        $('#site-nav, #toolbar-administration').show();
      }
    }

    function menuItemActive(className){
      const hash = window.location.hash;

      if(hash){
        $(className+' li').removeClass('active');
        $(className+' a[href="'+hash+'"]').parent().addClass('active');
      }
    }
  },
};
$(SticyNav.init.bind(SticyNav));
